import React from 'react';
import { Button, ButtonGroup } from '@mui/material';

interface Option {
    value: string;
    label: string;
}

interface GroupButtonProps {
    options: Option[];
    selectedValue: string;
    onChange: (value: string) => void;
    buttonStyle?: React.CSSProperties;
}

const GroupButton: React.FC<GroupButtonProps> = ({
    options,
    selectedValue,
    onChange,
    buttonStyle = {},
}) => {
    const getButtonStyles = (isSelected: boolean): React.CSSProperties => ({
        color: isSelected ? 'white' : '#5aac3d',
        backgroundColor: isSelected ? '#5aac3d' : '',
        borderColor: '#5aac3d',
        ...buttonStyle,
    });

    return (
        <ButtonGroup aria-label="Medium-sized button group" variant="outlined">
            {options.map((option) => (
                <Button
                    key={option.value}
                    onClick={() => onChange(option.value)}
                    style={getButtonStyles(selectedValue === option.value)}
                >
                    {option.label}
                </Button>
            ))}
        </ButtonGroup>
    );
};

export default GroupButton;
